import classNames from "classnames";
import CardTitle from "../../../components/CardTitle";
import TMapComp, { TextTag } from "../../../components/TMap";
import { SwiperTable } from "../../../components/SwiperTable";
import styles from "./WisdomPartyBuilding.module.scss";
import YearPicker from "../../../components/YearPicker";
import styled from "@emotion/styled";
import { Column } from "@ant-design/plots";
import { Pie } from "@ant-design/charts";
import { Col, Empty, Modal, Row, Table } from "antd";
import { ColumnsType } from "antd/es/table";
import middleBox1 from "../../../images/middle-box1.png";
import { MainLayout } from "../../../components/Layout";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import request from "../../../utils/request";
import DialogItemImg1 from "../../../images/modal-card1.png";
import { CommonHeader } from "./Modals/CommonHeader";
import BaseInfo from "./Modals/BaseInfo";
import { Land } from "./Modals/Land";
import { Project } from "./Modals/Project";
import { Policy } from "./Modals/Policy";
import { Operate } from "./Modals/Operate";
import { Energy } from "./Modals/Energy";
import { Intellectual } from "./Modals/Intellectual";
import { LiveTime } from "../../../components/LiveTime/index";
import EchartPie from "./Charts/Pie";
import EchartBar from "./Charts/Bar";
import Echart3DPie from "./Charts/3DPie";
import Echart3DBar from "./Charts/3DBar";
import { EmptyPage } from "./Modals/Empty";
import { isYushan } from "../../../config";
import { AnQuan } from "./Modals/AnQuan";
import { FangKui } from "./Modals/FangKui";
import { HuanBao } from "./Modals/HuanBao";
const BusinessManagementLayout = styled.div`
  .table-nobg {
    background-color: none;
    &:hover {
      background-color: #0e3e54;
    }
  }
  .table-bg {
    background-color: #0e3e54;
    &:hover {
      background-color: none;
    }
  }
  .left {
  }
  .infos {
    padding-right: 30px;
    .info-item {
      justify-content: space-between;
      align-items: center;
      height: 33px;
      padding: 0 110px 0 43px;
      color: #7bbcee;
      font-size: 18px;
      margin: 15px 0;
      &.bg-info {
        margin: 0;
      }
    }
  }
  .column-box {
    padding: 30px 30px 30px 10px;
  }
  .right {
  }
  .middle {
    /* left: calc(458px + 40px) !important;
    top: 10px !important ;
    right: 456px !important;
    background-image: none !important;
    padding-left: 20px;
    bottom: inherit; */
    padding-left: 10px;

    .middle-content {
      display: flex;
      justify-content: space-around;
      .middle-item {
        /* flex: 1; */
        width: 178px;
        aspect-ratio: 0.54;
        height: 96px;
        background-image: url(${middleBox1});
        background-repeat: no-repeat;
        .name {
          padding-top: 22px;
          color: #00caff;
          padding-left: 14px;
        }
        .middle-value {
          margin-top: 8px;
          text-align: center;
          position: relative;
          color: #00f1ff;
          font-size: 37px;
          font-style: italic;
          font-weight: 800;
          .point {
            position: absolute;
            right: 40px;
            font-size: 15px;
            bottom: 5px;
            font-style: normal;
            font-weight: 400;
          }
        }
      }
    }
  }
  .ant-modal .ant-modal-content {
    background-color: transparent;
  }
  .dialog-item {
    background-color: rgba(1, 104, 126, 0.9);
    border: 2px solid #00c9d0;
    box-shadow: 0 0 12px #00383f;
    border-radius: 8px;
    padding: 20px 25px;
  }
  .dialog-item1 {
    width: 1545px;
    min-height: 392px;
    max-height: 712px;
    /* background-size: contain;
    background-image: url(${DialogItemImg1});
    background-repeat: no-repeat; */
  }
  .dialog-item2 {
    width: 1545px;
    min-height: 513px;
    margin-top: 20px;
  }
  .ant-modal-wrap {
    z-index: 99999999999;
  }
  .ant-modal-footer {
    display: none;
  }
  .ant-modal-close {
    color: #fff;
    top: 54px;
    right: -40px;
    width: 50px;
    height: 50px;
    .ant-modal-close-x {
      font-size: 30px !important;
    }
  }
  .ant-modal .ant-modal-close:hover {
    color: #fff;
  }
`;

const BusinessManagement: React.FC = () => {
  const [companData, setCompanyData] = useState<Record<string, any>>({
    companyInfo: [],
    changes: {
      categories: [],
      line: [],
    },
    industry: [],
    fourup: [],
  });

  const [companyList, setCompanyList] = useState<any[]>([]);
  const [currentYear, setCurrentYear] = useState(
    new Date().getFullYear().toString()
  );
  const companyName = useRef("");
  // const [noRenderMaps, setNoRenderMaps] = useState<any[]>([]);
  const noRenderMaps = useRef<any[]>();
  const commonBoxRef = useRef<any>();
  const hasRenderMap = useRef<boolean>(false);
  const getCompanyInfo = async () => {
    try {
      const res = await request.get(
        `/screen/Index/getCompanyInfo?years=${currentYear}`
      );
      setCompanyData(res.data.data);
      console.log("resco", res);
    } catch (e) {}
  };

  const getCompanyList = async (isRenderMap = false) => {
    try {
      const res = await request.get(
        `/screen/Index/getCompany?keys=${companyName.current}`
      );
      const data = res?.data?.data.map((item: any) => {
        return {
          ...item,
        };
      });
      setCompanyList(data);
      if (!isRenderMap || hasRenderMap.current) return;
      const tempArr: object[] = [];
      const noRenderArr: object[] = [];
      // setProjects(data);
      data.forEach((record: any, index: number) => {
        if (record.maps) {
          const item = {
            gisdata: record.maps,
            label: record.name,
            id: record.id,
            // record: record,
            onClick: async () => {
              setType("company");
              // setTitle(record.name);
              setCurrentCompany(record);
              setVisible(true);
            },
          };
          if (index < 40) {
            tempArr.push(item);
          } else {
            noRenderArr.push(item);
          }
        }
      });
      noRenderMaps.current = [...noRenderArr];
      mapRef.current?.removeAllMarkers?.();
      hasRenderMap.current = true;
      mapRef.current?.setMarkers?.(false, tempArr);
    } catch (e) {}
  };

  useEffect(() => {
    getCompanyInfo();
    getCompanyList(true);
  }, [currentYear]);

  const columns: ColumnsType<any> = [
    {
      title: "序号",
      colSpan: 4,
      align: "center",
      render(_v, _r, index) {
        return <span>{index + 1}</span>;
      },
    },
    {
      title: "企业名称",
      align: "center",
      dataIndex: "name",
      render(_v, _r, index) {
        return <span style={{ cursor: "pointer" }}>{_v}</span>;
      },
    },
  ];

  const mapRef = useRef<any>(null);
  const [visible, setVisible] = useState(false);
  const parentRef = useRef<any>(null);

  const [activeIndex, setActiveIndex] = useState(0);
  const [currentCompany, setCurrentCompany] = useState<TextTag | undefined>(
    undefined
  );

  const modalContent = useMemo(() => {
    if (isYushan) {
      if (activeIndex === 0) return <BaseInfo id={currentCompany?.id} />;
      if (activeIndex === 1) return <Land id={currentCompany?.id} />;
      if (activeIndex === 2) return <Project id={currentCompany?.id} />;
      if (activeIndex === 3) return <Policy id={currentCompany?.id} />;
      if (activeIndex === 4) return <Operate id={currentCompany?.id} />;
      if (activeIndex === 5) return <Energy id={currentCompany?.id} />;
      if (activeIndex === 6) return <Intellectual id={currentCompany?.id} />;
      return <EmptyPage id={currentCompany?.id} />;
    }
    if (activeIndex === 0) return <BaseInfo id={currentCompany?.id} />;
    // if (activeIndex === 1) return <Land id={currentCompany?.id} />;
    if (activeIndex === 1) return <Project id={currentCompany?.id} />;
    // if (activeIndex === 3) return <Policy id={currentCompany?.id} />;
    if (activeIndex === 2) return <Operate id={currentCompany?.id} />;
    if (activeIndex === 3) return <Energy id={currentCompany?.id} />;
    // 环保信息
    if (activeIndex === 4) return <HuanBao id={currentCompany?.id} />;
    // 安全信息
    if (activeIndex === 5) return <AnQuan id={currentCompany?.id} />;
    //问题反馈
    if (activeIndex === 6) return <FangKui id={currentCompany?.id} />;
    // if (activeIndex === 4) return <Intellectual id={currentCompany?.id} />;
    return <EmptyPage id={currentCompany?.id} />;
  }, [activeIndex, currentCompany?.id]);
  const [type, setType] = useState("");
  const [currentType, setCurrentType] = useState<any>();
  const [currentIndex, setCurrentIndex] = useState<number>();
  useEffect(() => {
    if (!visible) {
      setCurrentCompany(undefined);
    }
  }, [visible]);
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const globalMap: any = TMap as any;
  const [zoom, setZoom] = useState(18.2);
  const goToArea = (item: any) => {
    mapRef.current?.zoomTo?.(zoom);
    const itemGisData = JSON.parse(item.gisdata || "[]");

    if (itemGisData.length) {
      const item = itemGisData[0];
      const center = item.geometry.center;
      setTimeout(() => {
        if (center) {
          mapRef.current?.panTo?.(center.lat, center.lng);
        } else {
          if (item.geometry.paths?.length) {
            // 计算多边形形心
            var position = globalMap.geometry.computeCentroid(
              item.geometry.paths.map(
                (item: any) => new globalMap.LatLng(item.lat, item.lng)
              )
            );
            mapRef.current?.panTo?.(position.lat, position.lng);
          }
        }
      }, 1000);
    }
  };
  const getCenter = (gisdata: string) => {
    const itemGisData = JSON.parse(gisdata || "[]");
    if (itemGisData.length) {
      const item = itemGisData[0];
      const center = item.geometry.center;
      if (center) {
        return center;
      } else {
        if (item.geometry.paths?.length) {
          // 计算多边形形心
          var position = globalMap.geometry.computeCentroid(
            item.geometry.paths.map(
              (item: any) => new globalMap.LatLng(item.lat, item.lng)
            )
          );
          return position;
        }
      }
    }
  };
  return (
    <BusinessManagementLayout>
      <div className={styles.commonBox}>
        <div className={styles.WisdomPartyBuilding} ref={parentRef}>
          <LiveTime />

          <MainLayout
            leftWidth={458}
            left={
              <div className={classNames("left")}>
                <div className={classNames(styles.flex, styles.cardTitle)}>
                  <CardTitle
                    titleStyles={{
                      paddingLeft: 65,
                    }}
                    title="企业信息"
                  />
                  <YearPicker
                    defaultValue={currentYear}
                    onChange={(e, dateStr) => {
                      setCurrentYear(dateStr);
                    }}
                  />
                </div>
                <div className="infos">
                  {companData?.companyInfo &&
                    companData?.companyInfo.length && (
                      <>
                        <EchartBar
                          dataOptions={[
                            {
                              name: companData?.companyInfo[0]?.title,
                              value: companData?.companyInfo[0]?.val,
                            },
                            {
                              name: companData?.companyInfo[2]?.title,
                              value: companData?.companyInfo[2]?.val,
                            },
                          ]}
                        />
                        <Row gutter={24} style={{ marginTop: -32 }}>
                          <Col span={12}>
                            <EchartPie
                              color="#ffe000"
                              dataOptions={[
                                {
                                  name: companData?.companyInfo[1]?.title,
                                  value: companData?.companyInfo[1]?.val,
                                },
                              ]}
                            />
                          </Col>
                          <Col span={12}>
                            <EchartPie
                              // color="#ffe000"
                              imageIndex={1}
                              dataOptions={[
                                {
                                  name: companData?.companyInfo[3]?.title,
                                  value: companData?.companyInfo[3]?.val,
                                },
                              ]}
                            />
                          </Col>
                        </Row>
                      </>
                    )}
                </div>
                <div className="changes">
                  <div className={styles.flex}>
                    <CardTitle title="企业变迁"></CardTitle>
                  </div>
                  <div>
                    {companData?.changes?.categories?.length && (
                      <Echart3DBar
                        dataOptions={companData?.changes?.categories?.map(
                          (item: any, index: number) => {
                            return {
                              name: item,
                              value: companData?.changes?.line[index],
                            };
                          }
                        )}
                      />
                    )}
                  </div>
                </div>
                <div className="industry">
                  <div className={styles.flex}>
                    <CardTitle title="行业分布"></CardTitle>
                  </div>
                  <div>
                    {companData?.industry && companData?.industry.length && (
                      <Echart3DPie
                        dataOptions={companData?.industry?.map((item: any) => {
                          return {
                            name: item.name,
                            value: item.value,
                          };
                        })}
                      />
                    )}
                  </div>
                </div>
              </div>
            }
            rightWidth={466}
            right={
              <div className={classNames(styles.rightContainer, "right")}>
                <CardTitle
                  titleStyles={{
                    paddingLeft: 65,
                  }}
                  title="企业列表"
                />

                <div className="common-box" ref={commonBoxRef}>
                  <div
                    className={styles.inputWrapper}
                    style={{ marginTop: 18 }}
                  >
                    <input
                      type="text"
                      placeholder="请输入企业名称"
                      onChange={(e) => {
                        companyName.current = e.target.value;
                      }}
                    />
                    <button
                      className={styles.searchBtn}
                      onClick={() => {
                        getCompanyList();
                      }}
                    >
                      搜索
                    </button>
                  </div>
                  <div className={styles.tableBox} style={{ marginTop: 28 }}>
                    <SwiperTable
                      columns={columns}
                      slidesHeight={740}
                      slidesPerView={9}
                      dataSource={companyList}
                      onClick={(record) => {
                        if (record.maps) {
                          goToArea({
                            gisdata: record.maps,
                          });
                          if (noRenderMaps.current) {
                            const tIndex = noRenderMaps.current?.findIndex(
                              (item, index) => {
                                return item.id === record.id;
                              }
                            );
                            if (tIndex > -1) {
                              const item = noRenderMaps.current?.[tIndex];
                              mapRef.current?.setMarkers?.(false, [item]);
                              noRenderMaps.current?.splice(tIndex, 1);
                            }
                          }
                        }
                        setVisible(true);
                        setCurrentCompany(record);
                        setType("company");
                      }}
                    />
                    {/* <Table
                      className={styles.table}
                      columns={columns}
                      dataSource={companyList}
                      scroll={{
                        y:
                          document.body.getBoundingClientRect().height -
                          commonBoxRef.current?.getBoundingClientRect().top -
                          64,
                      }}
                      pagination={false}
                      rowClassName={(record, index) => {
                        return index % 2 === 0 ? "table-nobg" : "table-bg";
                      }}
                      onRow={(record) => {
                        return {
                          // onMouseEnter: (e) => {
                          //   const dom = e.currentTarget;
                          //   // dom.style.background = "none";
                          //   if (dom.classList.contains("table-nobg")) {
                          //     dom.classList.add("table-bg");
                          //     dom.classList.remove("table-nobg");
                          //   } else {
                          //     dom.classList.add("table-nobg");
                          //   }
                          // },
                          // onMouseLeave: (e) => {
                          //   const dom = e.currentTarget;
                          //   if (dom.classList.contains("table-nobg")) {
                          //     dom.classList.add("table-bg");
                          //     dom.classList.remove("table-nobg");
                          //   } else {
                          //     dom.classList.add("table-nobg");
                          //   }
                          //   // dom.style.background = "#0e3e54";
                          // },
                          onClick: () => {
                            if (record.maps) {
                              goToArea({
                                gisdata: record.maps,
                              });
                              if (noRenderMaps.current) {
                                const tIndex = noRenderMaps.current?.findIndex(
                                  (item, index) => {
                                    return item.id === record.id;
                                  }
                                );
                                if (tIndex > -1) {
                                  const item = noRenderMaps.current?.[tIndex];
                                  mapRef.current?.setMarkers?.(false, [item]);
                                  noRenderMaps.current?.splice(tIndex, 1);
                                }
                              }
                            }
                            setVisible(true);
                            setCurrentCompany(record);
                            setType("company");
                          },
                        };
                      }}
                    /> */}
                  </div>
                </div>
              </div>
            }
            map={
              <TMapComp
                ref={mapRef}
                isFullScreen
                zoom={zoom}
                cluster={true}
                clusterLabel="家企业"
                onZoom={() => {
                  const map = mapRef.current?.map;
                  if (!map) return;
                  var bounds = map.getBounds();
                  const items = noRenderMaps.current?.reduce(
                    (init, item, index) => {
                      const center = getCenter(item.gisdata);
                      if (center) {
                        const isContains = bounds.contains(
                          new globalMap.LatLng(center.lat, center.lng)
                        );
                        if (isContains) {
                          init.push(item);
                          noRenderMaps.current?.splice(index, 1);
                        }
                      }
                      return init;
                    },
                    []
                  );
                  if (items && items.length) {
                    mapRef.current?.setMarkers?.(false, items);
                  }
                }}
                textTag={companyList
                  .filter((item) => !!item.position)
                  .map((item) => {
                    return {
                      id: item.id,
                      name: item.name,
                      position: item.position
                        ? item.position
                            .split(",")
                            .map((item: string) => Number(item))
                        : [],
                    };
                  })}
                onGeometryClick={(data) => {
                  console.log("data", data);
                  setCurrentCompany(data);
                  setType("company");
                  setVisible(true);
                }}
              />
            }
          >
            <div className={classNames("middle")}>
              <div className="middle-content">
                {companData?.fourup?.map((item: any, index: number) => {
                  return (
                    <div
                      key={index}
                      className="middle-item"
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        setVisible(true);
                        setType("fourup");
                        setCurrentIndex(index);
                        setCurrentType(item);
                      }}
                    >
                      <p className="name">{item.title}</p>
                      <div className="middle-value">
                        {item.val}
                        <span className="point">{item.unit}</span>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
            <Modal
              open={visible}
              getContainer={() => {
                return parentRef.current!;
              }}
              width={1545}
              onCancel={() => {
                setVisible(false);
              }}
            >
              {type === "company" && (
                <div className="dialog-item dialog-item1">
                  <CommonHeader
                    onTableChange={setActiveIndex}
                    id={currentCompany?.id}
                  />
                </div>
              )}
              {type === "company" && modalContent}
              {(type === "fourup" || type === "companyInfo") && (
                <div className="dialog-item dialog-item1">
                  <Policy
                    id={currentIndex}
                    placeholder={"请输入企业名称"}
                    modelTitle={currentType.title}
                    tableCols={[
                      {
                        title: "序号",
                        dataIndex: "",
                        align: "center",
                        render(_value: any, _record: any, index: number) {
                          return index + 1;
                        },
                      },
                      {
                        title: "企业名称",
                        align: "center",
                        dataIndex: "name",
                        render(_value: any, _record: any, index: number) {
                          return (
                            <div
                              style={{ cursor: "pointer" }}
                              onClick={() => {
                                setCurrentCompany(_record);
                                setType("company");
                                const record = companyList.find(
                                  (c) => c.id === _record.id
                                );
                                if (!record) return;
                                if (record.maps) {
                                  goToArea({
                                    gisdata: record.maps,
                                  });
                                  if (noRenderMaps.current) {
                                    const tIndex =
                                      noRenderMaps.current?.findIndex(
                                        (item, index) => {
                                          return item.id === record.id;
                                        }
                                      );
                                    if (tIndex > -1) {
                                      const item =
                                        noRenderMaps.current?.[tIndex];
                                      mapRef.current?.setMarkers?.(false, [
                                        item,
                                      ]);
                                      noRenderMaps.current?.splice(tIndex, 1);
                                    }
                                  }
                                }
                              }}
                            >
                              {_value}
                            </div>
                          );
                        },
                      },
                    ]}
                    policyType={"getCompanyList"}
                    date={currentYear}
                  />
                </div>
              )}
            </Modal>
          </MainLayout>
        </div>
      </div>
    </BusinessManagementLayout>
  );
};

export default BusinessManagement;
